export default __webpack_public_path__ + "static/media/ci_202311.a5f90b9a.png";